import { Details, ThisWeeksPerformanceBlock, LatestLoadsBlock, FuelCardSection } from "./truckPageConfComponents";
import { addNotification } from "../../supplementary_components/store";
import { parseTasks, parseLoads } from "../../general_components/content_management/task_list/taskListElements/diagramView";
import { NestedValueExtractor } from "../../general_components/content_management/list_view/listView";
import { TRUCK_SECTION_UPDATE } from '../../supplementary_components/itemEditMethods';
import { API_ROOT } from "../../supplementary_components/requests";
import { canSeeLoadRates } from "../../supplementary_components/userDataDelegate";
import { TRUCK_BLOCK, canSeeTruckBlock } from "./truckPageLayout";
import { isTruckGrossVisibleOnBoard, useBoardStore } from "../../main_board_components/boardStore";

export class TRUCK_POPUP_OBJECT {
    Details = ()=> {
        return Details(this, true);
    }
    constructor(){
        this.getLink = API_ROOT+'trucks/';
        this.columnProportions = "27rem 1fr 0.6fr";
    }
    setData(data){
        this.data = data;
        this.id = data['id'];
        this.truckNumber = data['truckNumber'];
        this.canSeeRates = canSeeLoadRates() && isTruckGrossVisibleOnBoard(data.id);
        this.trailerNumber = NestedValueExtractor(data, [["currentTrailer", "trailerNumber"]]);
        this.firstDriverFN = NestedValueExtractor(data, [['driver1', 'lastName'], ', ', ["driver1", "firstName"], ' ', ["driver1", "middleName"]]).replace(/ -$/, "");
        this.firstDriverSN = NestedValueExtractor(data, [["driver1", "firstName"], ' ', ['driver1', 'lastName']]);
        this.secondDriverFN = NestedValueExtractor(data, [['driver2', 'lastName'], ', ', ["driver2", "firstName"], ' ', ["driver2", "middleName"]]).replace(/ -$/, "");
        this.secondDriverSN = NestedValueExtractor(data, [["driver2", "firstName"], ' ', ['driver2', 'lastName']]);

        this.firstDriver = data["driver1"] ? {id: data["driver1"].id, label: this.firstDriverSN, type: "drivers"} : null;
        this.secondDriver = data["driver2"] ? {id: data["driver2"].id, label: this.secondDriverSN, type: "drivers"} : null;
        
        this.currentTrailer = data["currentTrailer"] ? {id: data["currentTrailer"].id, label: data["currentTrailer"].trailerNumber, type: "trailers"} : null;
        this.dispatcher = NestedValueExtractor(data, [["dispatcher", "firstName"], ' ', ["dispatcher", "lastName"]]);
        this.popup = true;
        
        this.data.thisWeeksLoads = parseLoads(this.data.thisWeeksLoads);
        this.data.thisWeeksDriverPayoutLoads = parseLoads(this.data.thisWeeksDriverPayoutLoads);
        
        
        if(this.data['tasks'] && this.data['tasks'].length > 0 && typeof(this.data['tasks'][0]) === 'string'){
            this.data['tasks'] = parseTasks(this.data['tasks']);
        }        
        this.status = data['status'];
        this.currentDrivers = (shortVersion)=>{
            const namesArray = [];
            const fdn = shortVersion ? this.firstDriverSN : this.firstDriverFN;
            const sdn = shortVersion ? this.secondDriverSN : this.secondDriverFN;
            if(fdn !== '-')namesArray.push(fdn);
            if(sdn !== '-')namesArray.push(sdn);
            return namesArray.join(' / ');
        }
        
        this.notes = data['allNotes'].filter((note) => note.type !== "loads");
        this.notes.sort((a, b) => new Date(a.dateTime) - new Date(b.dateTime));
        this.header = {
            title : "Truck ",
            titleSuffix: this.truckNumber.length < 10 ? this.truckNumber : "",
            titleVal: this.truckNumber.length < 10 ? "" : this.truckNumber,
            titlePath: `trucks/${this.id}`,
            onTitleNavigate: () => useBoardStore.getState().closePopup(),
            status : {
                value: this.status.textVal,
                colorCode: this.status.colorCode
            },
            suplementaryInfo: this.data?.currentFuelLevel ? `Fuel Level: ${this.data.currentFuelLevel}%` : this.currentDrivers(true),
        };
        this.infoSections = [
            {
                title: 'Details',
                editAccessLevel: { key: 'TRUCKS', level: 'MANAGE' },
                copyButton: () => {
                    navigator.clipboard.writeText
(`Truck: ${this.truckNumber};
${this.truckNumber === '-' ? 'PO' : 'Trailer: '+this.trailerNumber};
Driver(s): ${this.currentDrivers()};
Phone Number(s): ${NestedValueExtractor(data, [["driver1", "phoneNumber"], " / ", ["driver2", "phoneNumber"] ]).replace('- /', '').replace('/ -', '')}`)
                    addNotification({message:`Copied to clipboard`, type:'notify', duration: '1000'})
                },
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        TRUCK_SECTION_UPDATE(setDataMethod, this.data.id, this.Details);
                    }
                },
                columns : this.Details()
            },
            FuelCardSection(this.data)
        ]
        this.overviewSection = [
            canSeeTruckBlock(TRUCK_BLOCK.PERF) ? ThisWeeksPerformanceBlock(this) : null,
            LatestLoadsBlock(this),
        ]
        this.notesSection = {
            
        }
    }
}